import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import React from "react";

const AppSubHeader = ({ name }) => {
  return (
    <Box sx={{mt: 1, mb: 1, textAlign:'center'}}>
      <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>
        {name}
      </Typography>
    </Box>
  );
};

export default AppSubHeader;
